/**
 * Every Fortune-Sheet DOM id/class the Excel-parity keyboard/Esc shim reads
 * or dispatches against, gathered in one place instead of scattered string
 * literals across `escapePolicy.ts` and the keyboard-shortcut handlers.
 */

/** The grid's two special DOM ids — the cell input and the formula bar. */
export const CELL_INPUT_ID = 'luckysheet-rich-text-editor';
export const FORMULA_BAR_ID = 'luckysheet-functionbox-cell';

/** The fill-handle drag target. */
export const FILL_HANDLE_CLASS = 'luckysheet-cs-fillhandle';

/** Fortune renders the sheet-tab rename box `contentEditable` only while
 * actively renaming (react:7081-7083). */
export const TAB_RENAME_SELECTOR = '.luckysheet-sheets-item-name[contenteditable="true"]';

/** The library's own marquee overlay class (copy/cut selection). */
export const COPY_MARQUEE_SELECTOR = '.fortune-selection-copy';

/** An open right-click context menu. */
export const CONTEXT_MENU_SELECTOR = '.fortune-context-menu';

/** The toolbar itself, one of its combo controls, its combo popup, and the
 *  "More" overflow panel that holds toolbar items collapsed for width. */
export const TOOLBAR_SELECTOR = '.fortune-toolbar';
export const TOOLBAR_COMBO_SELECTOR = '.fortune-toolbar-combo';
export const TOOLBAR_COMBO_POPUP_SELECTOR = '.fortune-toolbar-combo-popup';
export const TOOLBAR_MORE_CONTAINER_SELECTOR = '.fortune-toolbar-more-container';
/** A toolbar dropdown/combo popup, or the "More" overflow panel. */
export const TOOLBAR_POPUP_SELECTOR = `${TOOLBAR_COMBO_POPUP_SELECTOR}, ${TOOLBAR_MORE_CONTAINER_SELECTOR}`;

/** The vertical/horizontal scrollbar tracks Fortune renders around the grid. */
export const SCROLLBAR_X_SELECTOR = '.luckysheet-scrollbar-x';

/** The portaled Name Box's own container, and the StatusBar's. */
export const NAME_BOX_CONTAINER_SELECTOR = '.fortune-name-box-container';
export const STATUS_BAR_CONTAINER_SELECTOR = '.fortune-stat-area';

/** One of Fortune's own `ModalProvider` dialogs (e.g. the format dropdown's
 * "More formats…"). */
export const LIBRARY_MODAL_SELECTOR = '.fortune-modal-container';

/** The library's own popover backdrop (context/filter/sheet-list menus). */
export const POPOVER_BACKDROP_SELECTOR = '.fortune-popover-backdrop';

/** A `ModalProvider` dialog's own header close icon, and its fallback Cancel
 * button when no close icon exists. */
export const MODAL_CLOSE_ICON_SELECTOR = '.fortune-modal-dialog-icon-close';
export const MODAL_CANCEL_BUTTON_SELECTOR = `${LIBRARY_MODAL_SELECTOR} .button-default`;
